import { USER_ROLES } from '../../../../constants/roles';
import { useRoles } from '../../../../hooks/useRoles';
import AgentAccountMenu from '../../../molecules/menus/AgentAccountMenu';
import NeobetAccountMenuButton from './AccountMenuButton';
import NeobetPlayerAccountMenu from './NeobetPlayerAccountMenu';

const menuMap = {
  [USER_ROLES.PLAYER]: NeobetPlayerAccountMenu,
  [USER_ROLES.AGENT]: AgentAccountMenu,
  [USER_ROLES.ADMIN]: AgentAccountMenu,
  [USER_ROLES.SUPER_ADMIN]: AgentAccountMenu,
  [USER_ROLES.MANAGER]: AgentAccountMenu,
  [USER_ROLES.TRADER]: AgentAccountMenu,
  [USER_ROLES.TECH_SUPPORT]: AgentAccountMenu,
};

type NeobetAccountMenuRendererProps = {
  showUnreadBadge?: boolean;
};

const NeobetAccountMenuRenderer = ({ showUnreadBadge = false }: NeobetAccountMenuRendererProps) => {
  const { role } = useRoles();
  const MenuComponent = menuMap[role] || NeobetPlayerAccountMenu;

  return (
    <MenuComponent
      showUnreadBadge={showUnreadBadge}
      showSummary={false}
      renderTrigger={({ onClick, isOpen }) => (
        <NeobetAccountMenuButton onClick={onClick} isOpen={isOpen} showUnreadBadge={showUnreadBadge} />
      )}
    />
  );
};

export default NeobetAccountMenuRenderer;
